"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InformationPanel = void 0;
var react_1 = __importDefault(require("react"));
var css_1 = require("@emotion/css");
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var design_system_typography_1 = require("@contrast-security-inc/design-system-typography");
var Panel_1 = require("../Panel");
var topSpacingCss = (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 8px;\n"], ["\n  margin-top: 8px;\n"])));
var bottomSpacingCss = (0, css_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: 8px;\n"], ["\n  margin-bottom: 8px;\n"])));
var rootContainerCss = (0, css_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
exports.InformationPanel = react_1.default.forwardRef(function (_a, ref) {
    var children = _a.children, _b = _a.title, title = _b === void 0 ? null : _b, _c = _a.subtitle, subtitle = _c === void 0 ? null : _c, _d = _a.detail, detail = _d === void 0 ? null : _d, Icon = _a.Icon, IconProps = _a.IconProps, testId = _a.testId, rest = __rest(_a, ["children", "title", "subtitle", "detail", "Icon", "IconProps", "testId"]);
    var selectedTheme = (0, design_system_foundations_1.useThemeContext)().selectedTheme;
    var hasContent = children || Icon || title || subtitle || detail;
    return hasContent ? (react_1.default.createElement(Panel_1.Panel, __assign({}, rest, { testId: testId, className: (0, css_1.cx)(rootContainerCss, rest === null || rest === void 0 ? void 0 : rest.className), ref: ref }),
        Icon && (react_1.default.createElement(Icon, __assign({ testId: testId && "".concat(testId, "-information-panel-icon"), size: "lg", color: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'neutral50', dark: 'neutral70' }) }, IconProps))),
        title && (react_1.default.createElement(design_system_typography_1.Text, { as: "h3", font: "titleH3", color: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'neutral100', dark: 'white' }), className: topSpacingCss }, title)),
        subtitle && (react_1.default.createElement(design_system_typography_1.Text, { as: "div", font: "body", color: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'neutral70', dark: 'darkTheme.white' }), className: bottomSpacingCss }, subtitle)),
        detail && (react_1.default.createElement(design_system_typography_1.Text, { as: "div", font: "body", color: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'neutral70', dark: 'darkTheme.white' }) }, detail)),
        react_1.default.createElement("div", { className: topSpacingCss }, children))) : null;
});
exports.InformationPanel.displayName = 'InformationPanel';
var templateObject_1, templateObject_2, templateObject_3;
